import React, { useState } from 'react';
import { MoreHorizontal, LogOut } from 'lucide-react';
import { Sheet } from './ds';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

const TabButton = ({ active, icon: Icon, label, onClick }) => (
  <button
    onClick={onClick}
    aria-current={active ? 'page' : undefined}
    style={{
      flex: '1 1 20%', minHeight: 44, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 2,
      border: 'none', background: 'transparent', cursor: 'pointer', fontFamily: FONT,
      color: active ? '#1B4098' : '#667085',
      padding: '6px 4px',
    }}
  >
    <Icon width={20} height={20} />
    <span style={{ fontSize: 11, fontWeight: active ? 600 : 500 }}>{label}</span>
  </button>
);

// Renders the first 4 NAV_ITEMS as tabs; anything beyond that (plus logout)
// lives behind a "Mehr" sheet so the bar never needs more than 5 slots.
const BottomTabBar = ({ items, activeAuditId, pathname, onNavigate, onSignOut, displayName, role }) => {
  const [moreOpen, setMoreOpen] = useState(false);
  const primaryItems = items.slice(0, 4);
  const moreItems = items.slice(4);
  const moreActive = moreItems.some(item => item.isActive(pathname));

  const go = (item) => {
    const target = item.resolvePath ? item.resolvePath(activeAuditId) : item.path;
    onNavigate(target);
    setMoreOpen(false);
  };

  return (
    <>
      <nav
        style={{
          position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 100,
          display: 'flex', background: '#FFFFFF', borderTop: '1px solid #D7DCE4',
          paddingBottom: 'var(--safe-bottom)',
          paddingLeft: 'var(--safe-left)', paddingRight: 'var(--safe-right)',
        }}
      >
        {primaryItems.map(item => (
          <TabButton
            key={item.key}
            active={item.isActive(pathname)}
            icon={item.icon}
            label={item.label}
            onClick={() => go(item)}
          />
        ))}
        {moreItems.length > 0 && (
          <TabButton active={moreActive} icon={MoreHorizontal} label="Mehr" onClick={() => setMoreOpen(true)} />
        )}
      </nav>

      <Sheet open={moreOpen} onClose={() => setMoreOpen(false)} title={displayName}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {role && <div style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 8 }}>{role}</div>}
          {moreItems.map(item => {
            const Icon = item.icon;
            const active = item.isActive(pathname);
            return (
              <button
                key={item.key}
                onClick={() => go(item)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12, minHeight: 44,
                  width: '100%', padding: '10px 12px', border: 'none', borderRadius: 8,
                  cursor: 'pointer', textAlign: 'left', fontFamily: FONT,
                  fontSize: 15, fontWeight: active ? 600 : 500,
                  background: active ? '#F2F6FE' : 'transparent',
                  color: active ? '#1B4098' : '#2C3646',
                }}
              >
                <Icon width={20} height={20} />
                {item.label}
              </button>
            );
          })}
          <button
            onClick={() => { setMoreOpen(false); onSignOut(); }}
            style={{
              display: 'flex', alignItems: 'center', gap: 12, minHeight: 44,
              width: '100%', padding: '10px 12px', border: 'none', borderRadius: 8,
              cursor: 'pointer', textAlign: 'left', fontFamily: FONT,
              fontSize: 15, fontWeight: 500, color: '#C22B31', background: 'transparent',
            }}
          >
            <LogOut width={20} height={20} />
            Abmelden
          </button>
          {process.env.REACT_APP_VERSION && (
            <div style={{ padding: '12px 12px 0', fontSize: 11, color: '#B6BDC9', textAlign: 'left' }}>
              v{process.env.REACT_APP_VERSION}
            </div>
          )}
        </div>
      </Sheet>
    </>
  );
};

export default BottomTabBar;
